module.exports = __webpack_public_path__ + "assets/request_feature.20d12780.svg";